module.exports = __webpack_public_path__ + "static/img/top-img.47042066.png";